// ■コンポーネント説明
// ニュース詳細表示用コンポーネント

import React, { useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import SEO from '@/components/seo';
import ContactBox from '@/components/Contact/ContactBox';
import UILabel from '@/components/UI/UILabel';
import * as Util from '@/components/Util';
import hoverCircle from '@/components/Interaction/hoverCircle';
import {
  FacebookShareButton,
  HatenaShareButton,
  TwitterShareButton,
} from 'react-share';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';
import * as styles from '@/styles/page/news.module.scss';
import UIBreadcrumb from '../UI/UIBreadcrumb';
import CDNReplace from '../CDNReplace';

export interface NewsDetailProps {
  data: GatsbyTypes.NewsPageQuery;
}

const NewsDetail: React.FC<NewsDetailProps> = (props) => {
  const { data } = props;
  const location = useLocation();
  useEffect(() => {
    hoverCircle();
  }, []);

  return (
    <>
      <SEO title={`${data.microcmsNews.title} | ニュース`} />
      <div className="page-wrap">
        <header className={styles.news_detail_header}>
          <div className={styles.news_detail_header__head}>
            <UILabel text={Util.newsLabel(data.microcmsNews.category[0])} />
            <time
              dateTime={
                data.microcmsNews.publishedAt
                  ? Util.formatDate(new Date(data.microcmsNews.publishedAt))
                  : Util.formatDate(new Date(data.microcmsNews.createdAt))
              }
              className={styles.news_date}
              style={{ marginLeft: `1.2rem` }}
            >
              {data.microcmsNews.publishedAt
                ? Util.formatDate(new Date(data.microcmsNews.publishedAt))
                : Util.formatDate(new Date(data.microcmsNews.createdAt))}
            </time>
          </div>
          <h1 className={styles.news_detail_header__title}>
            {data.microcmsNews.title}
          </h1>
        </header>
        <div className={styles.news_detail_contents}>
          <div className={styles.news_sns}>
            <TwitterShareButton
              title={data.microcmsNews.title}
              url={location.href}
              className={styles.news_sns__item}
            >
              <StaticImage
                loading="lazy"
                src="../../assets/images/news/icon-X.png"
                alt=""
              />
            </TwitterShareButton>
            <FacebookShareButton
              url={location.href}
              className={styles.news_sns__item}
            >
              <StaticImage
                loading="lazy"
                src="../../assets/images/news/icon-facebook.png"
                alt=""
              />
            </FacebookShareButton>
            <HatenaShareButton
              title={data.microcmsNews.title}
              url={location.href}
              className={styles.news_sns__item}
            >
              <StaticImage
                loading="lazy"
                src="../../assets/images/news/icon-hatena.png"
                alt=""
              />
            </HatenaShareButton>
          </div>
          {data.microcmsNews.body &&
            data.microcmsNews.body.map((body) => {
              let output = ``;
              if (body.rich) {
                output = body.rich;
              }
              if (body.plain) {
                output = body.plain;
              }
              return (
                <article
                  key={output}
                  className={styles.news_article}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: CDNReplace(output) }}
                />
              );
            })}
          <div className={styles.news_sns}>
            <TwitterShareButton
              title={data.microcmsNews.title}
              url={location.href}
              className={styles.news_sns__item}
            >
              <StaticImage
                loading="lazy"
                src="../../assets/images/news/icon-X.png"
                alt=""
              />
            </TwitterShareButton>
            <FacebookShareButton
              url={location.href}
              className={styles.news_sns__item}
            >
              <StaticImage
                loading="lazy"
                src="../../assets/images/news/icon-facebook.png"
                alt=""
              />
            </FacebookShareButton>
            <HatenaShareButton
              title={data.microcmsNews.title}
              url={location.href}
              className={styles.news_sns__item}
            >
              <StaticImage
                loading="lazy"
                src="../../assets/images/news/icon-hatena.png"
                alt=""
              />
            </HatenaShareButton>
          </div>
        </div>
      </div>
      {data.microcmsNews.contact && (
        <ContactBox service={data.microcmsNews.contact.id} />
      )}
      <UIBreadcrumb
        UpperItem={[[`News`, `/news`]]}
        CurrentItem={data.microcmsNews.title}
      />
    </>
  );
};

export default NewsDetail;
